import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchVisitAssessmentAreas = async ({ visitId, trialId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (visitId) params.append("visit_id", visitId);
  if (trialId) params.append("trial_id", trialId);

  const URL = `${__API_URL__}/api/photos/visit_assessment_areas/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useVisitAssessmentAreas = ({ visitId, trialId, enabled = true } = {}) => {
  return useQuery({
    queryKey: ["visit_assessment_areas", visitId, trialId],
    queryFn: () => fetchVisitAssessmentAreas({ visitId, trialId }),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export default useVisitAssessmentAreas;
